<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content [noPadding]="true">
  <data-table #packageListTable (detail)="onDetail($event)" (remove)="onRemove($event)" [columns]="columns" [title]="'Packages'"
              [dataProviderParams]="params" [dataProvider]="packageService" [searchColumns]="searchColumns" [searchAll]="true">
  </data-table>

</page-content>
